import React from 'react'
import Select from 'react-select'
import { LanguageSelectStyle } from './style'

const LanguageSelect = (props) => {
	return (
		<LanguageSelectStyle>
			<Select
				{...props}
				classNamePrefix='react-select'
				//menuIsOpen={true}
			/>
		</LanguageSelectStyle>
	)
}

export default LanguageSelect
